// extracted by mini-css-extract-plugin
export var footer = "_o5-0";
export var inherit = "_o5-1";
export var input = "_o5-2";
export var modalContent = "_o5-3";
export var quillEditor = "_o5-4";
export var subtitle = "_o5-5";